import type { Doc } from "building-types/doc";
import type { RoomLayoutEntityHandle } from "building-types/roomLayouts/roomLayoutTypes";
import { setIn } from "common/utils/objectUtils";
import { docEntityHandleHash } from "./core/handleHash";

export function docAddEntityToRoomLayout(doc: Doc, roomLayoutId: string, handle: RoomLayoutEntityHandle) {
  const hash = docEntityHandleHash(handle);
  return setIn(doc, ["entityRoomLayouts", hash], roomLayoutId);
}
